import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as MTooltip } from '@mui/material';
const Tooltip = (props) => {
    const { enterDelay = 500, enterNextDelay = 500 } = props;
    return (_jsx(MTooltip, Object.assign({}, props, { enterDelay: enterDelay, enterNextDelay: enterNextDelay })));
};
export default Tooltip;
